// src/campaigns/configs/campaigns.2029.ts

import { buildCampaignsForYear } from "./campaign-factory";

export const campaigns2029 = buildCampaignsForYear(2029);
